import { RAI_SSO_SERVICE_URL } from "../definitions.js"
import { RaissoError, ServiceResponse, errorFactory } from "../responses.js"
import { apiCall, /* responseValidation */ } from "../utils.js"
// import { userUpdateSchema, userDataUpdateSchema } from './utils.js'
import { RefreshTokenRequest, RefreshTokenResponse } from "./service-models.js"
import { R } from '@mobily/ts-belt'
// import { z } from 'zod'

const BASE_URL = `${RAI_SSO_SERVICE_URL}/token`

function traceError(e: unknown) {
  console.error('[token-controller] Error:', e)
}

/* const refreshTokenResponseValidator: z.ZodType<RefreshTokenResponse> = z.strictObject({
  token: z.string(),
  user_update: z.array(userUpdateSchema).optional(),
  user_data_update: userDataUpdateSchema.optional(),
})*/

class TokenController {
  private constructor() {/* empty */}

  private static _instance: TokenController

  public static get instance(): TokenController {
    if (!this._instance) {
      this._instance = new TokenController()
    }
    return this._instance;
  }

  public async refresh({ domainApiKey, refreshToken, appId }: RefreshTokenRequest): ServiceResponse<RefreshTokenResponse> {
    const url = `${BASE_URL}/refresh`
    const body = new URLSearchParams({
      domainApiKey: domainApiKey,
      refreshToken: refreshToken,
    })
    if (appId) {
      body.append('appId', appId)
    }
    try {
      const response = await apiCall<RefreshTokenResponse>(url, 'json', 'POST', { 'content-type': 'application/x-www-form-urlencoded' }, body);
      /* const value = R.map(response, responseValidation(refreshTokenResponseValidator)) */
      return response;
    } catch (e) {
      traceError(e)
      return R.Error(errorFactory(
        RaissoError,
        (e instanceof Error) ? e.message : 'Opps! Qualcosa è andato storto',
        { cause: e, context: { request: { url, body: body.toString() } } }
      ))
    }
  }

  public async check({ domainApiKey, accessToken, refreshToken, appId }: RefreshTokenRequest): ServiceResponse<RefreshTokenResponse> {
    if (!accessToken) {
      throw R.Error(errorFactory(RaissoError, "L'access_token è obbligatorio"));
    }
    const url = `${BASE_URL}/check`
    const body = new URLSearchParams({ domainApiKey, refreshToken })
    if (appId) {
      body.append('appId', appId)
    }
    try {
      const response = await apiCall<RefreshTokenResponse>(url, "json", "POST", {
        "content-type": "application/x-www-form-urlencoded",
        "X-Auth-Token": accessToken,
      }, body.toString())
      /* const value = R.map(response, responseValidation(refreshTokenResponseValidator)) */
      return response;
    } catch (e) {
      traceError(e)
      return R.Error(errorFactory(
        RaissoError,
        (e instanceof Error) ? e.message : 'Opps! Qualcosa è andato storto',
        { cause: e, context: { request: { url, body: body.toString() } } }
      ))
    }
  }
}

export default TokenController;
